import { useState } from "react";
import "./ProductPage.css";

const products = [
  {
    name: "ZeregBeam",
    tagline: "The Core Engine for Parallel Data Streams",
    description:
      "Orchestrates modular data pipelines, workflows, and simulations. Ensures tenants/modules operate simultaneously, efficiently, and aligned.",
    url: "acme.zeregbeam.bimzereg.com",
    color: "#1a73e8",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <rect x="8" y="8" width="48" height="48" rx="8" fill="#1a73e8" />
        <path d="M16 32L48 32" stroke="white" strokeWidth="4" strokeLinecap="round"/>
        <path d="M32 16L32 48" stroke="white" strokeWidth="4" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    name: "ZeregField",
    tagline: "Real-Time Site & Workflow Control",
    description:
      "Manage construction and building environments remotely. Monitor field data, operations, and resources concurrently across multiple locations.",
    url: "acme.zeregfield.bimzereg.com",
    color: "#34a853",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <circle cx="16" cy="16" r="4" fill="white"/>
        <circle cx="48" cy="16" r="4" fill="white"/>
        <circle cx="16" cy="48" r="4" fill="white"/>
        <circle cx="48" cy="48" r="4" fill="white"/>
        <path d="M16 16L48 48M48 16L16 48" stroke="white" strokeWidth="2"/>
      </svg>
    ),
  },
  {
    name: "ZeregDoc",
    tagline: "Organize, Standardize, & Share Data",
    description:
      "Create, store, and manage structured sheets, reports, and metadata forms. Keeps multi-tenant data aligned and accessible.",
    url: "acme.zeregdoc.bimzereg.com",
    color: "#fbbc05",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <rect x="12" y="8" width="40" height="48" rx="4" fill="#fbbc05"/>
        <line x1="16" y1="20" x2="48" y2="20" stroke="white" strokeWidth="3"/>
        <line x1="16" y1="30" x2="48" y2="30" stroke="white" strokeWidth="3"/>
        <line x1="16" y1="40" x2="48" y2="40" stroke="white" strokeWidth="3"/>
      </svg>
    ),
  },
  {
    name: "ZeregSync",
    tagline: "Seamless Data Alignment Across Modules",
    description:
      "Synchronize modules and tenant data in real time. Ensures workflows stay consistent and concurrent across your platform.",
    url: "acme.zeregsync.bimzereg.com",
    color: "#ea4335",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="24" stroke="white" strokeWidth="4"/>
        <path d="M32 8V24L40 16" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    name: "ZeregDesk",
    tagline: "Efficient Workspace & Resource Management",
    description:
      "Book desks, rooms, and shared spaces for teams. Track availability, schedule resources, and optimize usage across locations.",
    url: "acme.zeregdesk.bimzereg.com",
    color: "#a142f4",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <rect x="12" y="20" width="40" height="28" rx="4" fill="#a142f4"/>
        <line x1="12" y1="36" x2="52" y2="36" stroke="white" strokeWidth="3"/>
      </svg>
    ),
  },
  {
    name: "ZeregInsight",
    tagline: "Visualize, Analyze, Predict",
    description:
      "Advanced dashboards for KPIs, energy performance, or construction metrics. Make data-driven decisions with real-time analytics.",
    url: "acme.zereginsight.bimzereg.com",
    color: "#ff6d01",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <rect x="16" y="24" width="8" height="16" fill="white"/>
        <rect x="28" y="20" width="8" height="20" fill="white"/>
        <rect x="40" y="12" width="8" height="28" fill="white"/>
      </svg>
    ),
  },
  {
    name: "ZeregAuto",
    tagline: "Trigger Workflows, Events & Actions",
    description:
      "Create event-driven automation pipelines. Run tasks concurrently across modules, optimizing efficiency and parallel execution.",
    url: "acme.zeregauto.bimzereg.com",
    color: "#00bcd4",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="20" stroke="white" strokeWidth="4"/>
        <path d="M32 12V32L44 40" stroke="white" strokeWidth="3"/>
      </svg>
    ),
  },
  {
    name: "ZeregLink",
    tagline: "Connect Your Systems & Data",
    description:
      "Integrate external software, IoT, or cloud services. Supports concurrent workflows across platforms for seamless operations.",
    url: "acme.zereglink.bimzereg.com",
    color: "#ff4081",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <circle cx="20" cy="32" r="8" fill="white"/>
        <circle cx="44" cy="32" r="8" fill="white"/>
        <line x1="28" y1="32" x2="36" y2="32" stroke="white" strokeWidth="3"/>
      </svg>
    ),
  },
  {
    name: "ZeregVault",
    tagline: "Safe, Encrypted & Compliant",
    description:
      "Store sensitive documents and datasets securely. Manage permissions and protect tenant data while supporting simultaneous access.",
    url: "acme.zeregvault.bimzereg.com",
    color: "#7c4dff",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <rect x="16" y="16" width="32" height="32" rx="6" fill="#7c4dff"/>
        <circle cx="32" cy="32" r="6" stroke="white" strokeWidth="3"/>
      </svg>
    ),
  },
  {
    name: "ZeregFlow",
    tagline: "Forecast, Optimize, & Plan Ahead",
    description:
      "Run 'what-if' simulations for construction, energy, or business workflows. Model multiple scenarios concurrently to optimize decisions.",
    url: "acme.zeregflow.bimzereg.com",
    color: "#ff9800",
    icon: (
      <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <path d="M16 48L32 16L48 48H16Z" fill="white"/>
      </svg>
    ),
  },
];

function RegisterModal({ module, onClose }) {
  const [form, setForm] = useState({ tenant: "", email: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Backend API call placeholder
    await fetch("/api/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...form, module }),
    });
    alert(`Tenant created successfully for ${module}!`);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Register for {module}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Tenant / Company Name"
            value={form.tenant}
            onChange={(e) => setForm({ ...form, tenant: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="Admin Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
          <div className="modal-buttons">
            <button type="submit">Submit</button>
            <button type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function ProductsPage() {
  const [activeModule, setActiveModule] = useState(null);

  return (
    <div className="products-grid">
      {products.map((product, i) => (
        <div className="card" key={i} style={{ borderTopColor: product.color }}>
          <div className="card-icon">{product.icon}</div>
          <h3 className="card-title">{product.name}</h3>
          <p className="card-tagline">{product.tagline}</p>
          <p className="card-text">{product.description}</p>
          <p className="card-url">{product.url}</p>
          <button className="btn-register" onClick={() => setActiveModule(product.name)}>
            Register
          </button>
        </div>
      ))}
      {activeModule && <RegisterModal module={activeModule} onClose={() => setActiveModule(null)} />}
    </div>
  );
}
